module.exports = __webpack_public_path__ + "static/media/vip-icons-sprite.1eb5f3b2.svg";